import { MruCache } from 'owa-mru-cache';
import type ConversationItemParts from './schema/ConversationItemParts';

const cacheSize = 50;
const conversationCache: MruCache<ConversationItemParts> = new MruCache<ConversationItemParts>(
    'ConversationItemParts',
    cacheSize
);
export default conversationCache;
export function getConversationCache(): MruCache<ConversationItemParts> {
    return conversationCache;
}
